import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import BlogList from './pages/blog/BlogList';
import Post from './pages/blog/Post';
import Topic from './pages/blog/Topic';
import Theme from './theme/Theme';
import { useThemeContext } from './context/theme-context';

const App = () => {
  const { themeState } = useThemeContext();

  return (
    <main className={`${themeState.primary} ${themeState.background}`}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/topic/:slug" element={<Topic />} />
        <Route path="/blog/:slug" element={<Post />} />
      </Routes>
      <Theme />
    </main>
  );
};

export default App;
